// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__IcuBl","schemaTable":"Table_schemaTable__dfelQ","body":"Table_body__adlo4"};